import { ColumnFiltersState, SortingState, Updater } from '@tanstack/react-table';
import { isString, uniqBy } from 'lodash';
import { useCallback, useState } from 'react';

import { FilterType } from '../../_openapi/portfolio-optimizer';
import { DEFAULT_PAGE_SIZE } from '../../constants';

export const useTableState = ({
    columns,
    initialSort = [],
    initialFilters = [],
    defaultPageSize = DEFAULT_PAGE_SIZE,
}: {
    columns: any[];
    initialSort?: SortingState;
    initialFilters?: ColumnFiltersState;
    defaultPageSize?: number;
}) => {
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: defaultPageSize,
    });

    const [sorting, setSorting] = useState(initialSort);
    const [columnFilters, setColumnFilters] = useState(initialFilters);

    const _setColumnFilters = useCallback(
        (updaterOrValue: Updater<ColumnFiltersState>) => {
            const updated = typeof updaterOrValue === 'function' ? updaterOrValue(columnFilters) : updaterOrValue;
            const newFilters = uniqBy([...initialFilters, ...updated], 'id').map((f) => {
                const col = columns.find(({ id }) => id === f.id);

                return {
                    id: f.id,
                    value: perseFilterValue(f.value, col?.meta?.filterType),
                };
            });
            setColumnFilters(newFilters);
        },
        [columnFilters, columns, initialFilters],
    );

    return {
        pagination,
        setPagination,
        sorting,
        setSorting,
        columnFilters,
        setColumnFilters: _setColumnFilters,
    };
};

const perseFilterValue = (value: unknown, filterType?: FilterType) => {
    if (filterType === FilterType.DATE || filterType === FilterType.NUMBER) {
        return isString(value) ? JSON.parse(decodeURIComponent(value)) : value;
    }

    return value;
};
